import { STAGES } from './prospects';

export const CONTACT_VIEWS = [
  ['all', 'All'],
  ['tenant', 'Tenants'],
  ['prospect', 'Prospects'],
  ['applicant', 'Applicants'],
  ['owner', 'Owners'],
  ['vendor', 'Vendors']
];

export const TYPE_LABEL = { tenant: 'Tenant', prospect: 'Prospect', applicant: 'Applicant', owner: 'Owner', vendor: 'Vendor' };
export const TYPE_FAM = { prospect: 'info', applicant: 'purple', tenant: 'ok', owner: 'navy', vendor: 'neutral' };

const plural = (n, one, many = `${one}s`) => `${n} ${n === 1 ? one : many}`;

export function contactStatus({ type, status = {} }) {
  if (type === 'tenant') {
    if (status.tenantStatus === 'Active - Notice Given') return ['Notice given', 'bad'];
    if (status.tenantStatus === 'Terminated') return ['Moved out', 'neutral'];
    if (status.tenantStatus === 'Draft' || status.tenantStatus === 'Under Application / Prospect') return ['Lease pending', 'info'];
    return ['Current', 'ok'];
  }
  if (type === 'prospect' || type === 'applicant') return [status.pipelineStage || 'Lead', 'info'];
  if (type === 'owner') {
    const vac = status.vacant || 0;
    return [`${plural(status.units || 0, 'property', 'properties')}${vac ? ` · ${vac} vacant` : ''}`, vac ? 'warn' : 'neutral'];
  }
  if (type === 'vendor') {
    const n = status.openTickets || 0;
    return [n ? plural(n, 'open work order') : 'No open work', n ? 'info' : 'neutral'];
  }
  return ['', 'neutral'];
}

export const last10 = (phone) => String(phone || '').replace(/\D/g, '').slice(-10);

export const profilePath = (c) => `/contacts/${c.kind}/${c.id}`;

export const stageIndex = (stage) => STAGES.findIndex((s) => s.key === stage);

export const clientType = (c) =>
  c.tenantStatus != null || ['qualified', 'leased', 'lost'].includes(c.status)
    ? 'tenant'
    : stageIndex(c.pipelineStage) >= stageIndex('Application Submitted')
      ? 'applicant'
      : 'prospect';
